/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { restoreNumber } from "../../utils/validator/number";

const Pagination = ({
  page, limit, total, setPage, setLimit
}) => {
  const [maxPage, setMaxPage] = useState(0);
  const [displayPage, setDisplayPage] = useState(page + 1);
  const limitOption = [
    {
      label: "10개씩 보기",
      value: 10,
    },
    {
      label: "50개씩 보기",
      value: 50,
    },
    {
      label: "100개씩 보기",
      value: 100,
    },
  ];
  useEffect(() => {
    setDisplayPage(maxPage === 0 ? 1 : page + 1)
  }, [page, maxPage])

  /*
  const pageNum = Number(value)
  if (pageNum === 0 || pageNum > maxPage) return;

  setPage(pageNum);
*/
  useEffect(() => {
    const max = Math.ceil(total / limit);
    setMaxPage(max - 1 || 0);
  }, [limit, total]);

  const handleOnRowPerPageChange = (e) => {
    const { value } = e.target;
    setLimit(Number(value));
  };

  const handleOnPageChange = (page) => {
    let _page = Math.max(page, 0)
    _page = Math.min(_page, maxPage)
    setPage(_page)
    setDisplayPage(_page + 1)
  };

  const pre = () => {
    if (page === 0) return;
    setPage(page - 1);
  };

  const next = () => {
    if (page === maxPage) return;
    setPage(page + 1);
  };

  const currentList = () => {
    let firstList;
    let lastList;
    firstList = total === 0 ? 0 : page * limit + 1;
    lastList = (page + 1) * limit < total ? (page + 1) * limit : total;

    return `${firstList}-${lastList}`;
  };

  return (
    <div className="pagination">
      <div className="left-site">
        <div className="page-info-wrap">
          <span className="current-text">{currentList()}</span>
          <span className="total-text">&nbsp; / &nbsp;{total}</span>
        </div>
        <div className="select-wrap float-right">
          <select className="row-per-page" onChange={handleOnRowPerPageChange}>
            {limitOption.map((opt, idx) => (
              <option key={idx} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="right-site">
        <div className="page-input-wrap">
          <input
            className="page-input"
            value={displayPage}
            onChange={(e) => {
              setDisplayPage(Number(restoreNumber(e.target.value)))
            }}
            // onKeyDown={enterOnlyNumber}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleOnPageChange(maxPage > 0 ? Number(e.target.value) - 1 : 0)
              }
            }}
          />
          <span className="max-page">&nbsp; / &nbsp;{maxPage + 1}</span>
        </div>
        <div className="page-button-wrap">
          <button className="pre-button page-button" onClick={pre}>
            <span className="pre" />
          </button>
          <div className="divider" />
          <button className="next-button page-button" onClick={next}>
            <span className="next" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
